import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { updateMemoItems } from '@/features/yakureki/apis/yakurekiMemo'
import { useToast } from '@/shared/contexts/ToastContext'

interface UpdateMemoVariables {
  yakurekiId: string
  memoItems: string[]
}

/**
 * メモ更新Mutation
 *
 * SOAP結果画面でのメモ編集用。
 * 成功時に薬歴詳細キャッシュをinvalidate。
 */
export const useUpdateMemoMutation = () => {
  const queryClient = useQueryClient()
  const { showToast } = useToast()

  return useMutation({
    mutationFn: async ({ yakurekiId, memoItems }: UpdateMemoVariables) => {
      return await updateMemoItems(yakurekiId, memoItems)
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.yakureki.detail(variables.yakurekiId),
      })
    },
    onError: (error) => {
      const axiosError = error as {
        response?: { status?: number }
      }
      const status = axiosError.response?.status

      if (status === 404) {
        showToast('対象のデータが見つかりません', 'error', 5000)
      } else if (!navigator.onLine) {
        showToast('ネットワーク接続を確認してください', 'error', 5000)
      } else {
        showToast('メモの更新に失敗しました', 'error', 5000)
      }
    },
  })
}
